// extracted by mini-css-extract-plugin
module.exports = {"area":"NotificationsArea_area__3wXWH","notification":"NotificationsArea_notification__3fLDj"};